var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.885254 4.375C0.885254 2.32422 2.52588 0.625 4.63525 0.625H30.8853C32.936 0.625 34.6353 2.32422 34.6353 4.375V23.125C34.6353 25.2344 32.936 26.875 30.8853 26.875H4.63525C2.52588 26.875 0.885254 25.2344 0.885254 23.125V4.375ZM7.44775 15.625C6.92041 15.625 6.51025 16.0938 6.51025 16.5625C6.51025 17.0898 6.92041 17.5 7.44775 17.5H28.0728C28.5415 17.5 29.0103 17.0898 29.0103 16.5625C29.0103 16.0938 28.5415 15.625 28.0728 15.625H7.44775ZM7.44775 21.25H11.1978C11.6665 21.25 12.1353 20.8398 12.1353 20.3125C12.1353 19.8438 11.6665 19.375 11.1978 19.375H7.44775C6.92041 19.375 6.51025 19.8438 6.51025 20.3125C6.51025 20.8398 6.92041 21.25 7.44775 21.25ZM14.9478 21.25H22.4478C22.9165 21.25 23.3853 20.8398 23.3853 20.3125C23.3853 19.8438 22.9165 19.375 22.4478 19.375H14.9478C14.4204 19.375 14.0103 19.8438 14.0103 20.3125C14.0103 20.8398 14.4204 21.25 14.9478 21.25ZM24.7915 4.375C23.9712 4.375 23.3853 5.01953 23.3853 5.78125V8.59375C23.3853 9.41406 23.9712 10 24.7915 10H29.479C30.2407 10 30.8853 9.41406 30.8853 8.59375V5.78125C30.8853 5.01953 30.2407 4.375 29.479 4.375H24.7915Z",
    fill: "#465365"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.8cb55e9d7fec8e1bb2fab8972decc6e9.svg";
export { ForwardRef as ReactComponent };